import i18next from 'i18next';
import languageDectactor from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import GERMAN_TRANSLATION from './assets/translations/de.json';
import ENGLISH_TRANSLATION from './assets/translations/en.json';

// Here we the languages that we support
// If we support more languages, we also need to create their translation files
export enum Locale {
  en = 'en',
  de = 'de',
}

const getLanguage = (): Locale => {
  const language = navigator.language;

  if (language.startsWith('de')) {
    return Locale.de;
  }

  return Locale.en;
};

i18next
  .use(initReactI18next)
  .use(languageDectactor)
  .init({
    lng: getLanguage(),
    debug: true,
    fallbackLng: Locale.en,
    supportedLngs: [Locale.en, Locale.de],
    resources: {
      en: ENGLISH_TRANSLATION,
      de: GERMAN_TRANSLATION,
    },
    detection: {
      order: ['path', 'navigator', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'],
    },
  });

export default i18next;
